import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DescriptionIcon from '@mui/icons-material/Description';
import { styled } from "@mui/material";
import { LinkProps } from "react-router-dom";
import ApplicationAppService from '../application/platform/application-app-service';

const ListItemButtonLink = styled(ListItemButton)<LinkProps>(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  margin: theme.spacing(0.5, 1.5),
  padding: theme.spacing(1.25, 2),
  transition: 'all 0.2s ease-in-out',
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.contrastText,
    },
  },
}));

const applicationData = ApplicationAppService.getApplicationData();

export const mainListItems = (
  <React.Fragment>
    {applicationData.moduleId === 1 && (
      <React.Fragment>
        <ListItemButtonLink to="/dashboard">
          <ListItemIcon sx={{ minWidth: 42, color: 'inherit' }}>
            <DashboardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Dashboard"
            primaryTypographyProps={{
              fontSize: '0.9rem',
              fontWeight: 500
            }}
          />
        </ListItemButtonLink>
        <ListItemButtonLink to="/remessas-publicacao">
          <ListItemIcon sx={{ minWidth: 42, color: 'inherit' }}>
            <FileUploadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Remessas"
            primaryTypographyProps={{
              fontSize: '0.9rem',
              fontWeight: 500
            }}
          />
        </ListItemButtonLink>
        <ListItemButtonLink to="/diario-oficial">
          <ListItemIcon sx={{ minWidth: 42, color: 'inherit' }}>
            <FileCopyIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Diário Oficial"
            primaryTypographyProps={{
              fontSize: '0.9rem',
              fontWeight: 500
            }}
          />
        </ListItemButtonLink>
      </React.Fragment>
    )}
    {applicationData.moduleId === 2 && (
      <React.Fragment>
        <ListItemButtonLink to="/dashboard">
          <ListItemIcon sx={{ minWidth: 42, color: 'inherit' }}>
            <DashboardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Dashboard"
            primaryTypographyProps={{
              fontSize: '0.9rem',
              fontWeight: 500
            }}
          />
        </ListItemButtonLink>
        <ListItemButtonLink to="/unidades-entidade">
          <ListItemIcon sx={{ minWidth: 42, color: 'inherit' }}>
            <AccountTreeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Unidades"
            primaryTypographyProps={{
              fontSize: '0.9rem',
              fontWeight: 500
            }}
          />
        </ListItemButtonLink>
        <ListItemButtonLink to="/compras-licitacoes">
          <ListItemIcon sx={{ minWidth: 42, color: 'inherit' }}>
            <ShoppingCartIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Compras e Licitações"
            primaryTypographyProps={{
              fontSize: '0.9rem',
              fontWeight: 500
            }}
          />
        </ListItemButtonLink>
        <ListItemButtonLink to="/contratos">
          <ListItemIcon sx={{ minWidth: 42, color: 'inherit' }}>
            <DescriptionIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Contratos"
            primaryTypographyProps={{
              fontSize: '0.9rem',
              fontWeight: 500
            }}
          />
        </ListItemButtonLink>
      </React.Fragment>
    )}
  </React.Fragment>
);

export const secondaryListItems = (logout: () => void) => {
  return (
    <React.Fragment>
      <ListItemButton
        onClick={logout}
        sx={{
          borderRadius: 1,
          margin: '4px 12px',
          padding: '10px 16px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 42, color: 'inherit' }}>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Sair"
          primaryTypographyProps={{
            fontSize: '0.9rem',
            fontWeight: 500
          }}
        />
      </ListItemButton>
    </React.Fragment>
  );
};
